import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  GOOGLE_SSO_LOGIN,
  GOOGLE_SSO_LOGIN_SUCCESS,
  GOOGLE_SSO_LOGIN_ERROR,
  GOOGLE_SSO_SET_COOKIE,
  GOOGLE_SSO_SET_COOKIE_SUCCESS,
  GOOGLE_SSO_SET_COOKIE_ERROR,
  POST_SSO_ONLY_LOGIN_STATUS_SUCCESS,
  POST_SSO_ONLY_LOGIN_STATUS_ERROR,
  POST_SSO_ONLY_LOGIN_STATUS, OKTA_SSO_LOGIN, INITIATE_OKTA_LOGIN_FLOW,
} from "./actionTypes"


export const postSsoOnlyLoginStatus = (data) => {
    return {
        type: POST_SSO_ONLY_LOGIN_STATUS,
        payload: data,
    }
}

export const postSsoOnlyLoginStatusSuccess = (data) => {
    return {
        type: POST_SSO_ONLY_LOGIN_STATUS_SUCCESS,
        payload: data,
    }
}

export const postSsoOnlyLoginStatusError = (error) => {
    return {
        type: POST_SSO_ONLY_LOGIN_STATUS_ERROR,
        payload: error,
    }
}

export const googleSsoSetCookie = (data) => {

    return {
        type: GOOGLE_SSO_SET_COOKIE,
        payload: data,
    }
}

export const googleSsoSetCookieSuccess = (data) => {
    return {
        type: GOOGLE_SSO_SET_COOKIE_SUCCESS,
        payload: data,
    }
}

export const googleSsoSetCookieError = (error) => {
    return {
        type: GOOGLE_SSO_SET_COOKIE_ERROR,
        payload: error,
    }
}


export const googleSsoLogin = (access_token) => {
    return {
      type: GOOGLE_SSO_LOGIN,
      payload: {access_token},
    }
}

export const googleSsoLoginSuccess = (user) => {
    return {
      type: GOOGLE_SSO_LOGIN_SUCCESS,
      payload: user,
    }
}

export const googleSsoLoginError = (error) => {
    return {
      type: GOOGLE_SSO_LOGIN_ERROR,
      payload: error,
    }
}

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (type, history) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { type, history },
  };
};

export const oktaSsoLogin = () =>{
  return {
    type: OKTA_SSO_LOGIN,
  }
}

export const oktaSsoLoginSuccess = (data) =>{
  return {
    type: OKTA_SSO_LOGIN,
    payload: data,
  }
}

export const initiateOktaLoginFlow = (data) =>{
  return {
    type: INITIATE_OKTA_LOGIN_FLOW,
    payload: data,
  }
}
